// removed by extract-text-webpack-plugin
module.exports = {"tips_wrapper":"_1c30GMfBKAW1lv94y4iLqN","tip":"_1BsR2TUB8f0nglyCgAjWTp"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LecturePage/lecture-missions.scss
// module id = 1337
// module chunks = 0